import React from "react";
import "./index.css";

import img1 from "../../Components/images/power-grd.jpg";
import heroBg from "../../Components/images/About-Us.png";
import img2 from "../../Components/images/grid-system.jpg";

export default function LandingPage() {
  return (
    <div className="w-full">
      {/* Hero Section (like the UNDP screenshot) */}
      <div
        className="relative w-full h-screen bg-cover bg-center"
        style={{ backgroundImage: `url(${img1})` }}
      >
        {/* Gradient + Blur Overlay */}
        <div
          className="absolute inset-0"
          style={{
            background:
              "linear-gradient(to right, rgba(255,255,255,0.8), rgba(255,255,255,0))",
            backdropFilter: "blur(12px)",
            WebkitBackdropFilter: "blur(12px)",
          }}
        ></div>
        {/* /* Text Content */}
        <div className="relative z-10 flex flex-col justify-center items-start h-full px-8 sm:px-16 lg:px-32">
          <h1 className="text-4xl sm:text-5xl font-extrabold text-black mb-4">
            What We Do
          </h1>
          <p className="text-lg sm:text-xl text-black max-w-xl mb-6">
            Expert in renewable energy, sustainability engineering design, and
            project management.
          </p>
          <p className="text-lg sm:text-xl text-black max-w-xl mb-6">
            Driving innovation in renewable energy, engineering design, project
            management, and sustainability.
          </p>
          <a
            href="/our-services"
            className="inline-block bg-red-600 text-white px-6 py-3 text-sm font-semibold rounded hover:bg-red-700 transition"
          >
            Learn More →
          </a>
        </div>
      </div>
      {/* Existing About Us Section */}
      <section className="bg-white py-16 px-6 sm:px-12 lg:px-24">
        <h2 className="text-3xl sm:text-4xl font-bold mb-12 text-center">
          Who We Are
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
          <img
            src={img1}
            alt="Our Work"
            className="w-full rounded-xl shadow-md"
          />
          <p className="text-gray-700 text-lg leading-relaxed">
            Sustainable Energy and Technology Management (SETM) is a leading
            energy management firm committed to advancing clean energy solutions
            and supporting the transition to a net-zero future. We partner with
            families, businesses, governments, and utilities to deliver
            innovative energy systems that promote clean energy access, economic
            growth, and carbon reduction.
          </p>
          <p className="text-gray-700 text-lg leading-relaxed">
            Specializing in renewable energy services—from feasibility studies
            to mini-grid design, battery storage, and demand-side
            management—SETM ensures seamless project delivery with technical
            excellence and a client-focused approach. Our expert team is
            dedicated to creating impactful, sustainable solutions for a cleaner
            world.
            <br></br>
            <a href="/about-us">Learn More →</a>
          </p>

          <img
            src={img2}
            alt="Community"
            className="w-full rounded-xl shadow-md"
          />
        </div>
      </section>
    </div>
  );
}
